function formatNumber(value: any){
    return new Intl.NumberFormat('es-VE').format(value)
}

export default formatNumber